import React, {useState} from "react";
import EmployeeListPanel from "./EmployeeListPanel";
import ProgramProgressCard from "./ProgramProgressCard";
import { EMPLOYEES } from "./employeeData";
import AssignedCoursesCard from "./AssignedCoursesCard";

const EmployeeDashBoard = () => {
   const [selectedEmployee, setSelectedEmployee] = useState(EMPLOYEES[0]);

    return (
        <div className="flex flex-col">
            <div className="space-y-6">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                    <div className="col-span-1">
                        <EmployeeListPanel
                            employees={EMPLOYEES}
                            selectedEmployee={selectedEmployee}
                            onSelect={setSelectedEmployee}
                        />
                    </div>
                    <div className="col-span-2 space-y-6">
                        <ProgramProgressCard employee={selectedEmployee} />
                        <AssignedCoursesCard employee={selectedEmployee} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmployeeDashBoard;